import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Detail = ({
    show,
    handleClose,
    data
}) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">Detail Data</Modal.Title>
            <FalconCloseButton onClick={handleClose} variant="white" />
            </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <tbody>
                            <tr>
                                <td>Kode</td>
                                <td>{data.vccode}</td>
                            </tr>
                            <tr>
                                <td>Nama</td>
                                <td>{data.vcname}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

Detail.propTypes = {}

export default Detail;